







































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
  computed,
  watch,
  onBeforeMount,
} from '@vue/composition-api'

import { editUser } from '@/shared/api'
import { roles } from '@/shared/user/roles'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { User, Textbook, TextbookIssue } from '@/shared/types'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'EditUser',
  components: {
    CloseButton,
  },
  props: {
    user: Object,
  },
  setup(props, context) {
    const EditUserForm = ref(null)
    const data = reactive({
      valid: true,
      allowedTextbooks: [],
      allowedTextbookIssues: [],
      role: '',
      roleRules: [
        (v: string) => !!v || context.root.$t('inviteUserForm.role.required'),
      ],
    })
    const { textbooks } = useTextbookStore().getters

    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const textbookIssues = computed(() =>
      textbooks.value.reduce(
        (issues, textbook) => [...issues, ...textbook.issues],
        []
      )
    )
    const allowedRoles = Object.keys(roles).map((roleName: string) => ({
      value: roleName,
      label: context.root.$t(`role.${roleName}`),
    }))

    const initializeData = (user: User) => {
      data.allowedTextbooks = user.allowedTextbooks.map((textbookId: string) =>
        textbooks.value.find((textbook: Textbook) => textbook.id === textbookId)
      )
      data.allowedTextbookIssues = user.allowedTextbookIssues.map(
        (textbookIssueId: string) =>
          textbookIssues.value.find(
            (textbookIssue: TextbookIssue) =>
              textbookIssue.id === textbookIssueId
          )
      )
      data.role = user.role
    }

    onBeforeMount(() => initializeData(props.user as User))

    watch(() => props.user as User, initializeData)

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = EditUserForm.value
      form.validate()
      if (!data.valid) {
        return
      }
      loading.value = true
      try {
        const textbookIds = data.allowedTextbooks.map(
          (textbook: Textbook) => textbook.id
        )
        const textbookIssueIds = data.allowedTextbookIssues.map(
          (textbookIssue: TextbookIssue) => textbookIssue.id
        )
        const editedUser = await editUser(
          props.user.id,
          data.role,
          textbookIds,
          textbookIssueIds
        )
        loading.value = false
        $alert({
          text: context.root.$t('users.editSuccess'),
          type: 'success',
        })
        context.emit('user-edited', editedUser)
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      loading,
      EditUserForm,
      submit,
      textbooks,
      textbookIssues,
      allowedRoles,
    }
  },
})
